import { CamposGenericos } from "./camposGenericos";

export class Division extends CamposGenericos {
    
    defecto:boolean;
    descripcion: string;
    id: string;
    idCompania:string;
    idPais:string;
    idSalesOffice:string;
    idSalesOrg:string;
    salesOfficeCuenta:boolean;
}
